import { Tooltip } from "bootstrap";

export function initTooltips() {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  for (const tooltipTriggerEl of tooltipTriggerList) {
    new Tooltip(tooltipTriggerEl);
  }
}
